import useSecureAPI from "../hooks/usesecureapi";

const useWorldService = () => {
  const secureAPI = useSecureAPI();

  const getCountries = async () => {
    const response = await secureAPI.get("World/country");
    return response.data;
  };

  const getStateByCountryId = async (id: number) => {
    const response = await secureAPI.get(`World/state/bycountry/${id}`);
    return response.data;
  };

  const getCitiesByStateId = async (id: number) => {
    const response = await secureAPI.get(`World/city/bystate/${id}`);
    return response.data;
  };

  const getCitiesByCountryId = async (id = 194) => {
    const response = await secureAPI.get(`World/city/bycountry/${id}`);
    return response.data;
  };

  return {
    getCountries,
    getStateByCountryId,
    getCitiesByStateId,
    getCitiesByCountryId,
  };
};

export default useWorldService;
